import { connect } from "react-redux";

import MyPlan from "./MyPlan";
import {
  getSubscriptionPlan,
  pauseSubscription,
  upgradePlan,
  submitSubscriptionFeedback,
  createBillingCheckout,
  applyBillingPlanChange,
  createBillingPortalSession,
  getBillingPlans,
} from "./subscriptionActions";
const mapStateToProps = (state) => ({
  auth: state.auth,
  myPlan: state.subscription.myPlan,
  billingPlanChangeLoading: Boolean(state.subscription.billingMutationLoading),
  billingMutationError: state.subscription.billingMutationError || null,
  billingMutationType: state.subscription.billingMutationType || null,
  billingPortalSessionLoading: Boolean(
    state.subscription.billingPortalSessionLoading
  ),
  billingPlans: state.subscription.billingPlans,
  billingPlansLoading: Boolean(state.subscription.billingPlansLoading),
  billingPlansError: state.subscription.billingPlansError || null,
  isLoading:
    state.subscription.isLoading ||
    state.subscription.billingCheckoutLoading ||
    state.subscription.billingPortalSessionLoading ||
    state.subscription.billingMutationLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getSubscriptionPlan: (data) => dispatch(getSubscriptionPlan(data)),
  upgradePlan: (data) => dispatch(upgradePlan(data)),
  cancelPlan: () => dispatch({ type: "CANCEL_PLAN" }),
  manageSubscription: (data) => dispatch(pauseSubscription(data)),
  submitFeedback: (data) => dispatch(submitSubscriptionFeedback(data)),
  createBillingCheckout: (data) => dispatch(createBillingCheckout(data)),
  applyBillingPlanChange: (data) => dispatch(applyBillingPlanChange(data)),
  createBillingPortalSession: (data) =>
    dispatch(createBillingPortalSession(data)),
  getBillingPlans: () => dispatch(getBillingPlans()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyPlan);
